import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { ISiteSettingPair } from './UpdateSiteSettings';

/**
 * Request/response shapes for GET /api/exp/sites/{siteLuid}/settings, served
 * by RestApiSiteSettingsController#getSiteSettings in the monolith. The
 * controller takes a comma-separated `settings` query parameter and returns
 * a list of {key, value} pairs (string-typed values).
 */

export interface IGetSiteSettingsResponse {
  siteSetting?: ISiteSettingPair[];
}

export type GetSiteSettingsParams = {
  readonly settings: string;
};

function getSiteSettingsConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: 'exp',
    httpMethod: 'GET',
    endpoint: 'settings',
  };
}

export class GetSiteSettingsService {
  /**
   * Fetch the current values for the given V2 site setting keys.
   * The backend rejects empty/blank keys arrays with a 400.
   */
  public static getSiteSettings(keys: string[]): Promise<IGetSiteSettingsResponse> {
    if (keys.length === 0) {
      return Promise.resolve({ siteSetting: [] });
    }
    return makeJsonRestApiRequest<void, IGetSiteSettingsResponse, GetSiteSettingsParams>({
      config: getSiteSettingsConfig(),
      request: null,
      queryParams: { settings: keys.join(',') },
    });
  }
}
